var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12 no-content"},[_c('h3',[_vm._v(_vm._s(_vm.message))]),_c('b-btn',{staticClass:"mt-4",attrs:{"pill":"","variant":"primary"},on:{"click":_vm.RedirectTo}},[_vm._v("\n    "+_vm._s(_vm.buttonText)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }